<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <div class="note">
              <strong>Ghi chú:</strong>
              <div class="group-content-note">
                <div>
                  Dấu <span class="required">*</span> là bắt buộc phải điền
                </div>
                <div>
                  Tài khoản tối thiểu 6, tối đa 100 kí tự bao gồm chữ thường và
                  số
                </div>
                <div>
                  Mật khẩu tối thiểu 8, tối đa 128 kí tự bao gồm chữ hoa, chữ
                  thường, số và kí tự đặc biệt là 1 trong số kí tự này @$!%*?&
                </div>
                <div>
                  Số điện thoại gồm 10 kí tự và đúng định số điện thoại nước
                  Việt Nam không bao gồm SĐT cố định. Ví dụ: 033*****00 hoặc
                  8433*****00
                </div>
                <div>Email phải đúng định dạng. Ví dụ: demo@com.vn</div>
              </div>
            </div>
          </CCardHeader>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol xs="12" sm="12" md="8" lg="8" xl="8">
                  <CRow>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput
                        :options="userNameInput.options"
                        :data="userNameInput.data"
                      />
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput
                        :options="fullNameInput.options"
                        :data="fullNameInput.data"
                      />
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput
                        :options="passwordInput.options"
                        :data="passwordInput.data"
                      />
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput
                        :options="phoneInput.options"
                        :data="phoneInput.data"
                      />
                    </CCol>
                  </CRow>
                </CCol>
                <CCol sm="4" md="4" xl="4">
                  <div class="form-group form-input-wrapper">
                    <label class="col-form-label">Quyền tài khoản *</label><br/>
                    <div class="" style="display: inline-flex;">
                      <div v-for="each in rolesInput.data.items"
                           :key="each.value"
                           class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" v-model="rolesInput.data.model"
                               :value="each.value" :id="each.value"/>
                        <label class="custom-control-label mr-3" :for="each.value">{{ each.text }}</label>
                      </div>
                    </div>
                    <div
                      class="valid-error"
                      v-show="!rolesInput.data.validator.isValid">
                      {{ rolesInput.data.validator.errorMessage }}
                    </div>
                  </div>
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="4" md="4" xl="4">
                  <BaseInput
                    :options="emailInput.options"
                    :data="emailInput.data"
                  />
                </CCol>
                <CCol sm="4" md="4" xl="4">
                  <BaseSelect
                    :options="orgSelect.options"
                    :data="orgSelect.data"
                    ref="orgSelect"
                  ></BaseSelect>
                </CCol>
              </CRow>

              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData()"
                >
                  <i class="fa fa-plus"></i> Thêm mới
                </CButton>
                <CButton
                  color="secondary"
                  class="btn-action-primary"
                  @click="$router.go(-1)"
                ><i class="fa fa-reply"></i> Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";

export default {
  name: "UserAdd",
  components: {BaseSelect, BaseInput, BaseLoading},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Errors",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      /* Username */
      userNameInput: {
        options: {
          label: "Tên đăng nhập <span class='required'>*</span>",
          placeholder: "Tên đăng nhập",
          type: "text",
        },
        data: {
          name: "username",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.userNameInput.data.model;
              // let username_regex = /^([a-zA-Z0-9!%&@#$^*_]){6,}$/;
              let username_regex = /^([a-zA-Z0-9_]){6,100}$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên đăng nhập không được để trống";
              } else if (username_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Tên đăng nhập sai định dạng";
              } else if (username_regex.test(value) == true) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            },
          },
        },
      },
      /* Password */
      passwordInput: {
        options: {
          label: "Mật khẩu <span class='required'>*</span>",
          placeholder: "Mật khẩu",
          type: "password",
        },
        data: {
          name: "password",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.passwordInput.data.model;
              let password_regex =
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,128}$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Mật khẩu không được để trống";
              } else if (password_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Mật khẩu sai định dạng";
              } else if (password_regex.test(value) == true) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            },
          },
        },
      },
      /* Phone */
      phoneInput: {
        options: {
          label: "Số điện thoại <span class='required'>*</span>",
          placeholder: "Số điện thoại",
          type: "number",
        },
        data: {
          name: "phone",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.phoneInput.data.model;
              let phone_regex = /^(0[3|5|7|8|9])+([0-9]{8})$/;
              let phone_regex2 = /^(84[3|5|7|8|9])+([0-9]{8})$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Số điện thoại không được để trống";
              } else if (
                phone_regex.test(value) == false &&
                phone_regex2.test(value) == false
              ) {
                this.isValid = false;
                this.errorMessage = "Số điện thoại sai định dạng";
              } else if (
                phone_regex.test(value) == true ||
                phone_regex2.test(value) == true
              ) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            },
          },
        },
      },
      /* Org */
      orgSelect: {
        options: {
          label: "Đơn vị <span class='required'>*</span>",
          selectAllText: "Chọn đơn vị",
          filter: true,
          keyField: "value",
          valueField: "text",
        },
        data: {
          model: "",
          name: "orgId",
          source: {
            url: "/organization/list-org-active",
            response: function (dataResponse) {
              return dataResponse.data;
            },
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.orgSelect.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Đơn vị không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            },
          },
        },
      },
      /* Role */
      rolesInput: {
        data: {
          name: "roles",
          model: [],
          items: [],
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.rolesInput.data.model;
              if (value === undefined || value.length === 0) {
                this.isValid = false;
                this.errorMessage = "Vui lòng chọn Quyền";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      /* Email */
      emailInput: {
        options: {
          label: "Email <span class='required'>*</span>",
          placeholder: "Email",
        },
        data: {
          name: "email",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.emailInput.data.model;
              let email_regex =
                /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Email không được để trống";
              } else if (email_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Email không đúng định dạng";
              } else if (email_regex.test(value) == true) {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      /* FullName */
      fullNameInput: {
        options: {
          label: "Họ Tên <span class='required'>*</span>",
          placeholder: "Họ và tên",
        },
        data: {
          name: "fullName",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.fullNameInput.data.model;
              let fullname_regex =
                /^[a-zA-Z_ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀẾỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪếễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹý ]+$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Họ và tên không được để trống";
              } else if (fullname_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Họ và tên không đúng định dạng";
              } else if (fullname_regex.test(value) == true) {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
    };
  },
  methods: {
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= this.userNameInput.data.validator.valid();
      isValid &= this.passwordInput.data.validator.valid();
      isValid &= this.phoneInput.data.validator.valid();
      isValid &= this.emailInput.data.validator.valid();
      isValid &= this.fullNameInput.data.validator.valid();
      isValid &= this.orgSelect.data.validator.valid();
      if (!isValid) {
        return;
      }
      let dataRequest = {
        username: this.userNameInput.data.model,
        password: this.passwordInput.data.model,
        phone: this.phoneInput.data.model,
        email: this.emailInput.data.model,
        fullName: this.fullNameInput.data.model,
        orgId: this.orgSelect.data.model,
        roles : this.rolesInput.data.model
      };
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/users/addUser",
        dataSubmit: function () {
          return dataRequest;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({
              message: that.$helper.getStringError(response.data.data),
            });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Thêm mới tài khoản thành công",
            });
            that.$router.go(-1);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    loadDataRoles: function () {
      var that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/role/listRole",
        successCallback: function (response) {
          that.rolesInput.data.items = response.data.data;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    this.loadDataRoles();
  },
  watch: {},
};
</script>
